import axios from 'axios';
import moment from 'moment-timezone';

let currentCountry = null;
let currentTimezone = 'Asia/Shanghai';
// let currentCountry = 'CN';
// let currentTimezone = 'America/Mexico_City';

const COUNTRY_CONFIG = {
  CN: {
    name: 'China',
    timezone: 'Asia/Shanghai',
    label: '中国时间'
  },
  MX: {
    name: 'Mexico',
    timezone: 'America/Mexico_City',
    label: '墨西哥时间'
  }
};

export async function detectCountry() {
  if (currentCountry) {
    return currentCountry;
  }

  try {
    const response = await axios.get('https://ipapi.co/json/');
    const countryCode = response.data.country_code;

    if (countryCode === 'CN') {
      currentCountry = 'CN';
      currentTimezone = COUNTRY_CONFIG.CN.timezone;
    } else if (countryCode === 'MX') {
      currentCountry = 'MX';
      currentTimezone = COUNTRY_CONFIG.MX.timezone;
    } else {
      currentCountry = 'CN';
      currentTimezone = COUNTRY_CONFIG.CN.timezone;
    }

    sessionStorage.setItem('currentCountry', currentCountry);
    sessionStorage.setItem('currentTimezone', currentTimezone);

    return currentCountry;
  } catch (error) {
    currentCountry = 'CN';
    currentTimezone = COUNTRY_CONFIG.CN.timezone;
    sessionStorage.setItem('currentCountry', currentCountry);
    sessionStorage.setItem('currentTimezone', currentTimezone);
    return currentCountry;
  }
}

export function getCurrentCountry() {
  if (currentCountry) {
    return currentCountry;
  }
  return sessionStorage.getItem('currentCountry') || 'CN';
}

export function getCurrentTimezone() {
  if (currentTimezone) {
    return currentTimezone;
  }
  return sessionStorage.getItem('currentTimezone') || 'Asia/Shanghai';
}

export function getCountryLabel() {
  const country = getCurrentCountry();
  return COUNTRY_CONFIG[country]?.label || '中国时间';
}

export function formatTime(date, format = 'YYYY-MM-DD HH:mm:ss') {
  const timezone = getCurrentTimezone();
  if (!date) {
    return '';
  }

  if (typeof date === 'string') {
    if (date.includes('Z')) {
      return moment.utc(date).tz(timezone).format(format);
    }
    return moment.tz(date, 'Asia/Shanghai').tz(timezone).format(format);
  }

  return moment.tz(date, 'Asia/Shanghai').tz(timezone).format(format);
}

export function formatDate(date, format = 'YYYY-MM-DD') {
  return formatTime(date, format);
}

export function formatDateTime(date) {
  return formatTime(date, 'YYYY-MM-DD HH:mm:ss');
}

export function isChina() {
  return getCurrentCountry() === 'CN';
}

export function isMexico() {
  return getCurrentCountry() === 'MX';
}
